import { TemplateDefinition } from "@/components/AIComponents/ExportablesModal/templates/registry";
import { MainIdeaFormData } from "@/components/AIComponents/ExportablesModal/templates/MainIdeaOrganizer";
import {
  previewContainerCss,
  templateContainerCss,
  templateFormCss,
} from "./ExportablesTemplatePreview.style";

interface ExportablesPreviewProps {
  formData: MainIdeaFormData | any | null;
  setFormData: (data: any) => void;
  selectedExportable: TemplateDefinition<any> | null;
}

const ExportablesTemplatePreview = ({
  formData,
  setFormData,
  selectedExportable,
}: ExportablesPreviewProps) => {
  if (!selectedExportable) return null;
  const SelectedComponent = selectedExportable.Component;

  return (
    <div css={previewContainerCss}>
      <div css={templateContainerCss}>
        <form css={templateFormCss}>
          <SelectedComponent
            formData={formData}
            onChange={setFormData}
            title={selectedExportable.title}
          />
        </form>
      </div>
    </div>
  );
};

export default ExportablesTemplatePreview;
